import { render, staticRenderFns } from "./DeleteBackupServerDialog.vue?vue&type=template&id=d8dd83b2&"
import script from "./DeleteBackupServerDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteBackupServerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports